import { memo, useContext, useEffect, useState } from "react";
import Header from "../Header/Header";
import { Outlet } from "react-router-dom";
import { useGetMeQuery, useGetVipQuery } from "../../store/queries/auth.query";
import { StateContext } from "../../context/reducer";
import { getMe } from "../../context/actions";
import LoadingVideo from "../Common/Loading/LoadingVideo";
import { socket } from "../../helpers/socket.helper";
import { electronConstants } from "../../constant";
import LoginModal from "../Common/LoginModal/LoginModal";

const Layout = () => {
  const { state, dispatch } = useContext(StateContext);
  const { user } = state;
  const isVip = !!user?.is_vip && user?.is_vip !== "0";
  const accessToken = localStorage.getItem("accessToken");

  // Only fetch user data if accessToken exists
  const { isLoading, data: userData } = useGetMeQuery();
  const { data: vipData } = useGetVipQuery();
  const [vipStatus, setVipStatus] = useState(isVip);

  useEffect(() => {
    // Only connect socket if user is logged in
    if (user && accessToken) {
      const net = localStorage.getItem("net");
      const netData = net ? JSON.parse(net) : "";
      const netId = netData.id ? netData.id : "";
      socket.emit("login", {
        userId: user.id,
        netId: netId,
        publicIp: localStorage.getItem("publicIp"),
        localIp: localStorage.getItem("localIp"),
        macAddress: localStorage.getItem("mac"),
      });
    }
  }, [user, accessToken]);

  useEffect(() => {
    if (isVip) {
      setVipStatus(isVip);
    }
  }, [isVip]);

  useEffect(() => {
    // Clear user state if token was removed (invalid token scenario)
    if (!accessToken && user) {
      dispatch(getMe(null));
      return;
    }

    // Only process user data if accessToken exists and userData is available
    if (userData && accessToken) {
      if (vipData && user && vipStatus && !isVip) {
        setVipStatus(isVip);

        if (window.electron.sendToMain) {
          window.electron.sendToMain(electronConstants.LOG_OUT_STEAM);
        }

        socket.emit("disconnect_vip_rent_order", {
          userId: user.id,
        });
      }

      dispatch(getMe(userData));
    }

  }, [userData, user, vipData, isVip, vipStatus]);

  const navItems = [
    { title: "Chơi game", link: "/chitiet" },
  ];

  if(!!user) {
    navItems.push({ title: "Kho Game", link: "/quanlythue" });
  }

  // Only show loading if we're trying to fetch user data (when accessToken exists)
  return (isLoading && accessToken) ? (
    <LoadingVideo loading={true} />
  ) : (
    <>
      <Header
        navItems={navItems}
      />
      <div className="h-full overflow-y-auto overflow-x-hidden">
        <Outlet />
      </div>
      <LoginModal />
    </>
  );
};

export default memo(Layout);
